import React from 'react'
import Banner from '../components/banner'
import Cardsgroup from '../components/cardsgroup'


function Home() {
  return (
    <div> 
    <Banner/><br></br>
    <Cardsgroup/>
    
      
      
     </div>
  )
}

export default Home